import styled from 'styled-components';

export const Files = styled.div`
  display: flex;
  margin: 24px;
`;

export const File = styled.div`
  display: flex;
  width: 100%;
  border-radius: 6px;
  padding: 8px 10px;
  background: #f9f9f9;
  border: 2px solid #cccccc;
  align-items: center;

  svg:first-of-type {
    width: 30px;
    height: 40px;
    margin-right: 10px;
  }

  svg:nth-of-type(2) {
    margin-left: auto;
    cursor: pointer;
  }
`;

export const Container = styled.div`
  display: flex;
  padding: 36px 0;
  margin: 24px;
  cursor: pointer;
  border-radius: 4px;

  ${({ theme }) => `
    border: 2px dashed ${theme.colors.neutral.primary[40]};
    background-color: #fcfcfc;

    &:hover {
      border: 2px dashed ${theme.colors.neutral.primary[30]};
      background-color: white;
    }
  `};
`;

export const Labels = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;

  svg {
    width: 18px;
    height: 18px;
    transform: rotate(0.5turn);

    path {
      ${({ theme }) => `
        fill: ${theme.colors.neutral.primary[100]};
      `};
    }
  }

  span {
    font-weight: 500;

    ${({ theme }) => `
      color: ${theme.colors.accent.blue[100]};
    `};
  }
`;

export const DropLabel = styled.p`
  margin: 0;
`;

export const SupportLabel = styled.p`
  font-size: 14px;
  margin: 0;

  ${({ theme }) => `
    color: ${theme.colors.neutral.primary[70]};
  `};
`;
